module.exports = __webpack_public_path__ + "static/media/pic.a8d86694.png";